export function getBaseURL() {
  // return 'http://127.0.0.1:8787'
  return 'https://multitranslateapi.promptboom.org'
}
